/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://rfkf2ty5nrbv5jnoql5wwxc2ni.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-2:85aa4eab-4952-4eba-a61a-2510897a3368",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_lsiL5n9HP",
    "aws_user_pools_web_client_id": "33upqj8sj7q4i37hprbf1k9gd7",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "ObjectAudit-qabdr",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "alucio-beacon-content124658-qabdr",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
